import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import axios from '@/utils/request'
import {isURL} from '@/utils/validate'
import globalRoutes from './modules/global'
import {clearLoginInfo} from '@/utils/common'

Vue.use(VueRouter)

const mainRoutes = {
    path: '/',
    component: Layout,
    name: 'main',
    redirect: {name: 'login'},
    children: [
        {
            path: 'home',
            name: 'home',
            component: () => import('@/views/Panel')
        },
        {
            path: 'new',
            name: 'new',
            component: () => import('@/views/NewUI')
        }
    ],
    // beforeEnter (to, from, next) {
    //     let token = sessionStorage.getItem('token')
    //     if (!token || !/\S/.test(token)) {
    //         clearLoginInfo()
    //         next({ name: 'login' })
    //     }
    //     next()
    // }
}


/**
 * 获取当前路由类型
 * @param route
 * @param globalRoutes
 * @returns {global: 全局路由, main: 主视窗路由, 可扩展...}
 */
function getCurrentRouteType(route, globalRoutes = []) {
    let temp = []
    for (let i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? getCurrentRouteType(route, temp) : 'main'
}

function initDynamicMenuRoutes(menuList = [], routes = []) {
    let temp = []
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].menuEntityList && menuList[i].menuEntityList.length >= 1) {
            temp = temp.concat(menuList[i].menuEntityList)
        } else if (menuList[i].routerUrl && /\S/.test(menuList[i].routerUrl)) {
            menuList[i].routerUrl = menuList[i].routerUrl.replace(/^\//, '')
            let route = {
                path: menuList[i].routerUrl.replace('/', '-'),
                component: null,
                name: menuList[i].routerUrl.replace('/', '-'),
                meta: {
                    id: menuList[i].id,
                    title: menuList[i].permissionName,
                    isDynamic: true,
                    isTab: true,
                    iframeUrl: ''
                }
            }
            // URL以'http(s)://'开头，通过iframe展示
            if (isURL(menuList[i].routerUrl)) {
                route['path'] = `i-${menuList[i].id}`
                route['name'] = `i-${menuList[i].id}`
                route['meta']['iframeUrl'] = menuList[i].routerUrl
            } else {
                try {
                    route['component'] = () => import(`@/views/modules/${menuList[i].routerUrl}`) || null
                } catch (e) {
                    console.log(`%c${e} 页面路由组件异常！`, 'color:blue')
                }
            }
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        initDynamicMenuRoutes(temp, routes)
    } else {
        mainRoutes.name = 'main-dynamic'
        mainRoutes.children = routes
        router.addRoutes([
            mainRoutes,
            {path: '*', redirect: {name: '404'}}
        ])
        sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    }
}

const router = new VueRouter({
    dynamicRoutesLoaded: false,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: globalRoutes.concat(mainRoutes)
})

router.beforeEach((to, from, next) => {
    if (router.options.dynamicRoutesLoaded || getCurrentRouteType(to, globalRoutes) === 'global') {
        next()
    } else {
        axios.get('/general-service/v1/user/getUserInfoByToken', {}).then(res => {
            if (res && res.code === '00') {
                router.options.dynamicRoutesLoaded = true
                // TODO: 调试代码
                // res.body.menuTree = []
                // res.body.menuTree.push({
                //     "id":90,
                //     "parentId":93,
                //     "permissionName":"项目管理",
                //     "permissionType":93,
                //     "routerUrl":"service/project",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":90,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":911,
                //     "parentId":92,
                //     "permissionName":"技术通知管理",
                //     "permissionType":92,
                //     "routerUrl":"service/techPack",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":92,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":912,
                //     "parentId":92,
                //     "permissionName":"任务管理",
                //     "permissionType":92,
                //     "routerUrl":"service/task",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":92,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":91,
                //     "parentId":93,
                //     "permissionName":"询价管理",
                //     "permissionType":93,
                //     "routerUrl":"service/askPrice",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":91,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":92,
                //     "parentId":92,
                //     "permissionName":"报价管理",
                //     "permissionType":92,
                //     "routerUrl":"service/reportPrice",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":92,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":93,
                //     "parentId":92,
                //     "permissionName":"合同管理",
                //     "permissionType":92,
                //     "routerUrl":"service/contract",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":93,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":931,
                //     "parentId":92,
                //     "permissionName":"价格协议管理",
                //     "permissionType":92,
                //     "routerUrl":"service/priceAgreement",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":93,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":94,
                //     "parentId":93,
                //     "permissionName":"订单管理",
                //     "permissionType":93,
                //     "routerUrl":"service/order",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":94,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":95,
                //     "parentId":93,
                //     "permissionName":"交货管理",
                //     "permissionType":93,
                //     "routerUrl":"service/delivered",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":95,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":96,
                //     "parentId":93,
                //     "permissionName":"绩效管理",
                //     "permissionType":93,
                //     "routerUrl":"service/performance",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":96,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":97,
                //     "parentId":93,
                //     "permissionName":"结算管理",
                //     "permissionType":93,
                //     "routerUrl":"service/pay",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":97,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                // res.body.menuTree.push({
                //     "id":98,
                //     "parentId":93,
                //     "permissionName":"供应商管理",
                //     "permissionType":93,
                //     "routerUrl":"service/supplier",
                //     "icon":"el-icon-s-unfold",
                //     "sortNo":97,
                //     "expression":null,
                //     "menuEntityList":[
                //
                //     ]
                // })
                initDynamicMenuRoutes(res.body.menuTree)
                sessionStorage.setItem('menuList', JSON.stringify(res.body.menuTree || '[]'))
                let expressions = res.body.button.map(perm => {
                    return perm.expression
                })
                sessionStorage.setItem('expressions', JSON.stringify(expressions || '[]'))
                next({...to, replace: true})
            } else {
                clearLoginInfo()
                sessionStorage.setItem('menuList', '[]')
                sessionStorage.setItem('expressions', '[]')
                next()
            }
        }).catch((e) => {
            console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！`, 'color:blue')
            router.push({name: 'login'})
            // //TODO 开发用
            // router.options.dynamicRoutesLoaded = true
            // sessionStorage.setItem('menuList', JSON.stringify(list().data || '[]'))
            // initDynamicMenuRoutes(list().data)
            // next({...to, replace: true})
        })
    }
})

export default router
